<div class="triage-indicator" data-testid="triage-status">
    <hive-icon-component class="triage-indicator-icon" [icon]="faCrosshairs" size="small"></hive-icon-component>
    <span class="triage-indicator-label" data-testid="triage-indicator-label">TRIAGE MODE</span>
    <hive-button
        class="triage-indicator-dismiss"
        data-testid="triage-exit"
        title="Exit triage"
        emphasis="tertiary"
        size="smallest"
        [icon]="faXmark"
        (click)="exitTriage.emit()"
    ></hive-button>
</div>
